import { render, staticRenderFns } from "./taxResidentWagesList.vue?vue&type=template&id=8a7b0fbc&scoped=true&"
import script from "./taxResidentWagesList.vue?vue&type=script&lang=js&"
export * from "./taxResidentWagesList.vue?vue&type=script&lang=js&"
import style0 from "./taxResidentWagesList.vue?vue&type=style&index=0&id=8a7b0fbc&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7b0fbc",
  null
  
)

export default component.exports